import React from "react";
import PropTypes from "prop-types";

import Table from "./Table";
import EmptyState from "../Common/EmptyState";
import { cn } from "../../shadcn/lib/utils";

const ListTable = ({
  rows,
  loading = false,
  emptyMessage,
  minWidth,
  className,
  ...tableProps
}) => (
  <div className="w-full min-w-0">
    <Table
      {...tableProps}
      rows={rows}
      minWidth={minWidth}
      // Same 56px list rows as before the migration.
      className={cn("[&>tbody>tr]:h-14", className)}
    />
    {!loading && rows.length === 0 && emptyMessage ? (
      <EmptyState title={emptyMessage} compact />
    ) : null}
  </div>
);

ListTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool,
  emptyMessage: PropTypes.node,
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

export default ListTable;
